export default __webpack_public_path__ + "static/media/Quick_Actions_Filled.f79d6e4c.svg";